<template>
    <div>
        <header class="header" style="direction: ltr !important;">
            <a :href="shopUrl" class="logo">
                <h2 class="logo__heading">Braster</h2>
                <img class="logo__image" src="../../assets/images/braster-logo.png" alt="Braster" />
            </a>
            <div class="header__container">
                <nav class="nav" :class="{ show: showMobileMenu }">
                    <ul class="nav__row">
                        <li class="login-buy nav__list">
                            <template v-if="userShopUrl">
                                <a
                                    :href="userShopUrl"
                                    class="nav__link login-buy"
                                    style="color:#cf004a;line-height: 40px;height: 40px;"
                                    >{{ $t('BUY_ONLINE') }}</a
                                >
                            </template>
                            <template v-else>
                                <span
                                    class="nav__link login-buy"
                                    style="color:#cf004a;line-height: 40px;height: 40px;"
                                    >{{ $t('BUY_ONLINE') }}</span
                                >
                            </template>
                        </li>
                        <li v-if="!isUserLogged" class="login-buy nav__list">
                            <button @click="login" style="font-size: 16px" class="nav__link login-buy">
                                {{ $t('LOGIN') }}
                            </button>
                        </li>
                        <li v-if="isUserLogged" class="login-buy nav__list">
                            <button @click="logout" style="font-size: 16px" class="nav__link login-buy">
                                {{ $t('LOGOUT') }}
                            </button>
                        </li>
                        <!--MENU DLA NIEZALOGOWANEGO-->

                        <template>
                            <!--                            <template v-if="!isUserLogged">-->
                            <li class="nav__list">
                                <a
                                    class="nav__link"
                                    :href="eSklepUrl + $t('LINK_FIRMA_START')"
                                    style="font-size: 16px"
                                    >{{ $t('ABOUT_COMPANY') }}</a
                                >
                            </li>
                            <!--                            <li class="nav__list">-->
                            <!--                                <a-->
                            <!--                                    class="nav__link"-->
                            <!--                                    :href="eSklepUrl + $t('LINK_SKUTECZNOSC_START')"-->
                            <!--                                    style="font-size: 16px"-->
                            <!--                                    >{{ $t('EFFICIENCY') }}</a-->
                            <!--                                >-->
                            <!--                            </li>-->

                            <li class="nav__list">
                                <a
                                    class="nav__link"
                                    :href="eSklepUrl + $t('LINK_TECHNOLOGY')"
                                    style="font-size: 16px"
                                    >{{ $t('TECHNOLOGY') }}</a
                                >
                            </li>
                            <li class="nav__list">
                                <a
                                    class="nav__link"
                                    :href="eSklepUrl + $t('LINK_BRASTER®PRO')"
                                    style="font-size: 16px"
                                    >{{ $t('BRASTER®PRO') }}</a
                                >
                            </li>
                            <li class="nav__list">
                                <a
                                    class="nav__link"
                                    :href="eSklepUrl + $t('LINK_EXAMINATION')"
                                    style="font-size: 16px"
                                    >{{ $t('EXAMINATION') }}</a
                                >
                            </li>
                            <li class="nav__list">
                                <a
                                    class="nav__link"
                                    :href="eSklepUrl + $t('LINK_PROFILAKTYKA')"
                                    style="font-size: 16px"
                                    >{{ $t('PREVENTION') }}</a
                                >
                            </li>
                            <li class="nav__list">
                                <a class="nav__link" :href="eSklepUrl + $t('LINK_NEWS')" style="font-size: 16px">
                                    {{ $t('NEWS') }}
                                </a>
                            </li>
                            <li class="nav__list">
                                <a class="nav__link" :href="$t('LINK_RELACJE_INWESTORSKIE')" style="font-size: 16px">
                                    {{ $t('RELACJE_INWESTORSKIE') }}
                                </a>
                            </li>
                            <li class="nav__list">
                                <a class="nav__link" :href="eSklepUrl + $t('LINK_CONTACT')" style="font-size: 16px">
                                    {{ $t('CONTACT') }}
                                </a>
                            </li>
                        </template>

                        <!--                        <template v-if="isUserLogged && accountTypeIsPro">-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_WHAT_IS_BRASTER_PRO')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('WHAT_IS_BRASTER_PRO') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_HOW_DOES_BRASTER_PRO_WORK')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('HOW_DOES_BRASTER_PRO_WORK') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_SKUTECZNOSC_PRO')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('EFFICIENCY') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_TECHNOLOGY_PRO')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('TECHNOLOGY') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a class="nav__link" :href="eSklepUrl + $t('LINK_CONTACT')" style="font-size: 16px">{{-->
                        <!--                                    $t('CONTACT')-->
                        <!--                                }}</a>-->
                        <!--                            </li>-->
                        <!--                        </template>-->

                        <!--                        <template v-if="isUserLogged && !accountTypeIsPro">-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_CZYM_JEST_BRASTER')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('ABOUT_BRASTER') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_JAK_DZIALA_BRASTER')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('HOW_IT_WORKS') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_SKUTECZNOSC')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('EFFICIENCY') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                            <li class="nav__list">-->
                        <!--                                <a-->
                        <!--                                    class="nav__link"-->
                        <!--                                    :href="eSklepUrl + $t('LINK_PROFILAKTYKA')"-->
                        <!--                                    style="font-size: 16px"-->
                        <!--                                    >{{ $t('PREVENTION') }}</a-->
                        <!--                                >-->
                        <!--                            </li>-->
                        <!--                        </template>-->
                    </ul>
                </nav>

                <div class="header-right">
                    <!--                    <template v-if="userShopUrl">-->
                    <!--                        <a-->
                    <!--                            :href="userShopUrl"-->
                    <!--                            class="-button-red -small-button buttons-container__button"-->
                    <!--                            style="line-height: 40px;height: 40px;font-size: 16px;"-->
                    <!--                            >{{ $t('BUY_ONLINE') }}-->
                    <!--                        </a>-->
                    <!--                    </template>-->
                    <!--                    <template v-else>-->
                    <!--                        <span-->
                    <!--                            class="-button-red -small-button buttons-container__button login-buy-disabled"-->
                    <!--                            style="line-height: 40px;height: 40px;font-size: 16px;cursor: default"-->
                    <!--                            >{{ $t('BUY_ONLINE') }}-->
                    <!--                        </span>-->
                    <!--                    </template>-->
                    <button
                        v-if="!isUserLogged"
                        @click="login"
                        class="-button-light-grey -small-button buttons-container__button"
                        style="line-height: 40px;height: 40px;font-size: 16px;"
                    >
                        {{ $t('LOGIN') }}
                    </button>
                    <button
                        v-if="isUserLogged"
                        @click="logout"
                        class="-button-light-grey -small-button buttons-container__button"
                        style="line-height: 40px;height: 40px;font-size: 16px;"
                    >
                        {{ $t('LOGOUT') }}
                    </button>

                    <div class="choose-language">
                        <div class="dropdown" :class="{ open: isDropdownOpen }">
                            <button
                                class="-button-light-grey dropdown-toggle app-btn--small app-btn-default"
                                data-toggle="dropdown"
                                style="width: 40px"
                                @click="isDropdownOpen = !isDropdownOpen"
                            >
                                {{ $t('LANG') }}
                            </button>
                            <div class="dropdown-menu">
                                <h5>{{ $t('PAGE_LANGUAGE') }}</h5>
                                <ul class="switch-lng__list">
                                    <li
                                        class="switch-lng__list__item"
                                        v-for="lang in interfaceLanguages"
                                        @click="changeLanguage(lang)"
                                    >
                                        <img class="switch-lng__flag" :src="`/src/assets/images/flags/${lang}.png`" />
                                        {{ $t('NAME_NATIVE', lang) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <button @click="showMobileMenu = !showMobileMenu" class="hamburger">
                    <span class="hamburger__lines"></span>
                </button>
            </div>
        </header>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { config, init, logoutUser } from '../../main';
import { interfaceLanguages } from '../../countries';

export default {
    data() {
        return {
            showMobileMenu: false,
            isDropdownOpen: false,
            eSklepUrl: config.eSklepUrl,
            interfaceLanguages,
        };
    },
    computed: {
        ...mapState(['isUserLogged', 'interfaceLanguage']),
        ...mapGetters(['userShopUrl', 'accountTypeIsPro']),
        shopUrl() {
            return `${this.eSklepUrl}/${this.interfaceLanguage === 'pl' ? 'pl' : 'en'}`;
        },
    },
    methods: {
        login() {
            this.showMobileMenu = false;
            this.$router.push('/logowanie');
        },
        logout() {
            this.showMobileMenu = false;
            logoutUser();
        },
        changeLanguage(lang) {
            if (this.isUserLogged) {
                const languages = {
                    documentLanguage: lang,
                    interfaceLanguage: lang,
                };
                this.$http.patch('/user/api/settings/currentLanguages', languages).then(() => init(lang));
            } else {
                init(lang);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/***************/

/*LOGIN / LOGOUT*/

.login__container {
    float: right;
}

.arLogo {
    right: 60px;
}

@media (max-width: 1200px) {
}

/**************/
.switch-lng__list {
    margin: 0;
    padding: 0;
}

.switch-lng__list__item {
    cursor: pointer;
    display: block;
    margin: 0 0 10px;
    padding: 0;
}

.switch-lng__flag {
    margin-right: 5px;
    width: 20px;
}

.dropdown,
.dropdown-login {
    display: inline-block;
}

.dropdown-menu {
    border-radius: 4px;
    left: auto;
    min-width: 140px;
    right: 0;
    padding: 15px;
    transition: all 0.3s;
}

.dropdown-menu:before {
    content: '';
    width: 107px;
    box-sizing: border-box;
    border-left: 1px solid #ede8e4;
    border-right: 1px solid #ede8e4;
    position: absolute;
    right: -1px;
    background-color: #fff;
    height: 32px;
    top: -32px;

    display: none;
}

.dropdown-login .dropdown-menu {
    right: 70px;
    top: 55px;
}

.dropdown-menu h5 {
    font-weight: 600;
    margin: 0 0 10px;
}

.-button-red {
    background-color: #cf004a;
    color: #fff;
    border: 2px solid #cf004a;
}

.-button-red:hover {
    background-color: transparent;
    color: #cf004a;
}

.-small-button {
    font-size: 1rem;
    height: 50px;
    line-height: 37px;
    padding: 0rem 1.25rem 0rem 1.25rem;
    border-width: 1px;
}

.buttons-container__button {
    margin-right: 1.25rem;
    line-height: 3.125rem;
    display: inline-block;
    font-weight: 700;

    border-radius: 6.25rem;
    text-align: center;
    padding: 0 1.875rem;
    outline: none;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    font-family: 'Ek Mukta', sans-serif;
}

.-button-light-grey {
    border: 2px solid #cdc9c6;
    color: #706c69;
}

.-button-light-grey:hover {
    border-color: #cf004a;
    color: #cf004a;
}

.-button-light-grey:hover:before {
    border-color: #cf004a transparent transparent transparent;
}

/* http://meyerweb.com/eric/tools/css/reset/
       v2.0 | 20110126
       License: none (public domain)
    */

html,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}

body {
    margin: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
}

input,
textarea {
    font-family: inherit;
    -webkit-appearance: none;
}

/* HTML5 display-role reset for older browsers */

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
    display: block;
}

body {
    line-height: 1;
}

a {
    text-decoration: none;
}

ol,
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

blockquote,
q {
    quotes: none;
}

blockquote:before,
blockquote:after {
    content: '';
    content: none;
}

q:before,
q:after {
    content: '';
    content: none;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

.clearfix:before,
.clearfix:after {
    content: '';
    display: table;
}

.clearfix:after {
    clear: both;
}

.clearfix {
    zoom: 1;
    /* For IE 6/7 (trigger hasLayout) */
}

div {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

html,
body {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 16px;
    color: #333333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media only screen and (max-width: 990px) {
    html,
    body {
        font-size: 12px;
    }
}

@media only screen and (max-width: 767px) {
    html,
    body {
        font-size: 13px;
    }
}

html,
body {
    overflow-x: hidden;
}

html.sticked,
body.sticked {
    overflow: hidden;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type='number'] {
    -moz-appearance: textfield;
}

p {
    color: #706c69;
    font-weight: 400;
    line-height: 1.25rem;
}

button {
    outline: none;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0;
}

h2 {
    font-weight: 700;
    font-size: 2.5rem;
}

@media only screen and (max-width: 767px) {
    h2 {
        font-size: 2.187rem;
        line-height: 2.187rem;
    }
}

.-smaller-h2 {
    font-size: 1.375rem;
    margin-bottom: 1.25rem;
    margin-top: 2.187rem;
}

@media only screen and (max-width: 767px) {
    .-smaller-h2 {
        margin-bottom: 0.312rem;
    }
}

img.full-image {
    width: 100%;
    max-width: 100%;
}

h3 {
    font-weight: 600;
    font-size: 1.5rem;
}

@media only screen and (max-width: 767px) {
    h3 {
        font-size: 1.25rem;
    }
}

.-bigger-h3 {
    font-size: 2.812rem;
}

.custom-object-fit {
    position: relative;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.custom-object-fit img {
    opacity: 0;
}

span {
    font-weight: 800;
    font-family: 'Ek Mukta', sans-serif;
    font-size: 1.125rem;
}

a {
    color: #333333;
    outline: none;
}

b {
    font-weight: 700;
}

i {
    font-style: italic;
}

img {
    outline: none;
}

.inner {
    max-width: 1170px;
    width: 92%;
    margin: 0 auto;
}

sup {
    vertical-align: super;
    font-size: smaller;
}

.home .carousel-block {
    display: none;
}

.home .carousel-block.flex {
    display: none;
}

.home .slick-initialized .carousel-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.home .doctors-opinions .carousel-block {
    display: none;
}

.home .doctors-opinions .carousel-block.flex {
    display: none;
}

.home .doctors-opinions .slick-initialized .carousel-block {
    display: block;
}

.heading {
    font-weight: 700;
    font-size: 1.875rem;
    margin-bottom: 1.25rem;
    margin-top: 2.187rem;
}

.heading--small {
    font-size: 1.625rem;
    font-weight: 700;
    line-height: 1.75rem;
}

@media only screen and (max-width: 767px) {
    .heading--small {
        font-size: 1.25rem;
    }
}

.heading--big {
    font-size: 3.75rem;
    font-weight: 700;
}

@media only screen and (max-width: 767px) {
    .heading--big {
        font-size: 2.5rem;
        line-height: 2.5rem !important;
    }
}

.heading--medium {
    font-size: 2.187rem;
    font-weight: 700;
    line-height: 2.5rem;
    margin-bottom: 1.25rem;
    margin-top: 2.187rem;
}

@media only screen and (max-width: 767px) {
    .heading--medium {
        font-size: 1.875rem !important;
    }
}

.heading--extra-small {
    font-size: 1.375rem;
    line-height: 1.5rem;
}

@media only screen and (max-width: 767px) {
    .heading {
        font-size: 1.375rem;
        line-height: 1.5rem;
    }
}

.red-small-heading {
    font-size: 1.125rem;
    font-weight: 700;
    color: #cf004a;
}

.arrow-link {
    color: #cf004a;
    font-size: 0.875rem;
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.arrow-link:after {
    content: '';
    // background: url("../../dist/images/general/arrow-red.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 0.812rem;
    height: 0.437rem;
    margin-left: 0.625rem;
}

.arrow-link:hover {
    text-decoration: underline;
}

.-small-paragraph {
    font-size: 0.875rem;
    line-height: 1rem;
}

@media only screen and (max-width: 767px) {
    .-small-paragraph {
        text-align: center;
    }
}

.-white-text {
    color: #fff;
}

.red-label {
    background-color: #fff;
    font-size: 0.75rem;
    color: #cf004a;
    border: 1px solid #cf004a;
    font-weight: 700;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    padding: 0.25rem 1.25rem 0.25rem 1.25rem;
    text-transform: uppercase;
}

.header {
    height: 80px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 30px;
    -webkit-box-shadow: 0 0.125rem 0.875rem 0 rgba(35, 34, 33, 0.2);
    box-shadow: 0 0.125rem 0.875rem 0 rgba(35, 34, 33, 0.2);

    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 9998;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 40px;
}

.header__container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
    margin-left: 2rem;
}

.header--ri {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}

@media only screen and (max-width: 1340px) {
    .header {
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .nav {
        top: 80px;
    }
}

@media only screen and (max-width: 767px) {
    .header {
        height: 70px;
        padding: 0rem 0.625rem 0rem 0.625rem;
    }

    .header.centered-header {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
}

.login-buy {
    display: none !important;
}

@media only screen and (max-width: 500px) {
    .-small-button {
        display: none;
    }
    .login-buy {
        display: block !important;
    }
}

.standard-text {
    font-weight: 500;
    font-size: 1rem;
    color: #706c69;
    line-height: 1.25rem;
}

.standard-text--big {
    font-weight: 500;
    color: #333333;
    line-height: 1.875rem;
    font-size: 1.562rem;
}

.standard-text--big.-margin {
    margin-bottom: 2.187rem;
}

@media only screen and (max-width: 767px) {
    .standard-text--big {
        font-size: 1.25rem;
    }
    .arLogo {
        top: -15px;
    }
}

.standard-text--medium {
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.625rem;
    color: #333333;
}

.standard-text--medium.-margin {
    margin: 2.187rem 0;
}

.standard-text--medium.-bold {
    font-weight: 700;
}

.standard-text--medium-rare {
    color: #333333;
    font-size: 1.375rem;
    line-height: 1.5rem;
    font-weight: 600;
}

.standard-link {
    color: #cf004a;
    font-weight: 700;
}

.standard-link:hover {
    text-decoration: underline;
}

.standard-link.-block {
    display: block;
    margin-top: 0.625rem;
}

.square-list__list {
    position: relative;
    padding-left: 1.625rem;
    font-size: 1rem;
    color: #333333;
    font-weight: 400;
    margin-bottom: 1.25rem;
}

.square-list__list:last-child {
    margin-bottom: 0;
}

.square-list__list:before {
    content: '';
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0.375rem;
    height: 0.375rem;
    background-color: #cf004a;
}

.heading-description {
    color: #333333;
    font-size: 1.562rem;
    line-height: 1.625rem;
    margin-top: 0.937rem;
}

.heading2 {
    font-size: 1.375rem;
    font-weight: 700;
}

.check-icon {
    width: 1.5rem;
    height: 1.5rem;
    // background: url("../../dist/images/general/quest.png") no-repeat;
    background-size: cover;
    background-position: center;
    display: inline-block;
}

.close-icon {
    width: 1.125rem;
    height: 1.125rem;
    // background: url("../../dist/images/general/x.png") no-repeat;
    background-size: cover;
    background-position: center;
    display: inline-block;
}

.hamburger {
    display: none;
    width: 80px;
    height: 70px;
    border-left: 1px solid #ede8e4;
    position: absolute;
    background-color: rgba(237, 232, 228, 0.1);
    right: 0;
    top: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: box-shadow 0.25s ease-in-out, background-color 0.25s ease-in-out;
    -webkit-transition: background-color 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: box-shadow 0.25s ease-in-out, background-color 0.25s ease-in-out;
    transition: box-shadow 0.25s ease-in-out, background-color 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
}

@media only screen and (max-width: 1340px) {
    .hamburger {
        display: block;
        width: 70px;
    }
}

@media only screen and (max-width: 767px) {
    .hamburger {
        width: 60px;
    }
}

.hamburger__lines {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-transition: background-color 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out;
    height: 2px;
    background-color: #cf004a;
    width: 30%;
}

.hamburger__lines:before,
.hamburger__lines:after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #cf004a;
    -webkit-transition: transform 0.25s ease-in-out, top 0.25s ease-in-out, bottom 0.25s ease-in-out;
    -webkit-transition: top 0.25s ease-in-out, bottom 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
    transition: top 0.25s ease-in-out, bottom 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out, top 0.25s ease-in-out, bottom 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out, top 0.25s ease-in-out, bottom 0.25s ease-in-out,
        -webkit-transform 0.25s ease-in-out;
}

.hamburger__lines:before {
    top: -5px;
}

.hamburger__lines:after {
    bottom: -5px;
}

.hamburger.clicked {
    -webkit-box-shadow: 0px 0.125rem 0.875rem 0px rgba(35, 34, 33, 0.1);
    box-shadow: 0px 0.125rem 0.875rem 0px rgba(35, 34, 33, 0.1);
    background-color: #fff;
}

.hamburger.clicked:after {
    width: 100%;
    position: absolute;
    bottom: -2px;
    left: 0;
    height: 5px;
    background-color: #fff;
    content: '';
    z-index: 2;
}

.hamburger.clicked .hamburger__lines {
    background-color: transparent;
}

.hamburger.clicked .hamburger__lines:before {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 0;
}

.hamburger.clicked .hamburger__lines:after {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    bottom: 0;
}

.logo {
    min-width: 166px;
    width: 166px;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
}

.logo__heading {
    font-size: 0;
}

.logo__image {
    height: 100%;
    width: 100%;
}

.logo__text {
    color: #706c69;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    margin-top: 0.125rem;
    margin-right: 0.625rem;
}

@media only screen and (max-width: 767px) {
    .logo__text {
        margin-right: 0.312rem;
        font-size: 9px;
    }
}

@media only screen and (max-width: 1250px) {
    .logo {
        margin-right: 1.25rem;
    }
}

@media only screen and (max-width: 767px) {
    .logo {
        width: 10rem;
        min-width: 8rem;
        margin: 0 0 25px 15px;
    }
}

.nav {
    display: inline-block;
    height: 100%;
    position: relative;
    margin: 0 2.5rem;
}

.nav__list {
    display: inline-block;
    height: 100%;
}

.nav__list:last-child {
    margin-right: 0;
}

.nav__list.active .nav__link {
    border-color: #cf004a;
}

.nav__list--subnav {
    display: none;
}

.nav__list--prev .nav__link {
    color: #cf004a;
}

.nav__list--prev .nav__link:before {
    content: '';
    width: 0.812rem;
    // background: url("../../dist/images/general/arrow-red.png") no-repeat;
    background-size: cover;
    background-position: center;
    height: 0.437rem;
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    margin-right: 1.25rem;
}

.nav__list--login {
    width: 100%;
}

.nav__list--login:before {
    display: none;
}

.nav__link {
    font-weight: 700;
    font-size: 15px;
    white-space: nowrap;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0rem 1.25rem 0rem 1.25rem;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 2px solid transparent;
    -webkit-transition: border-color 0.25s ease-in-out;
    transition: border-color 0.25s ease-in-out;
}

.nav__link:hover {
    border-color: #cf004a;
}

@media only screen and (max-width: 1440px) {
    .nav__link {
        padding: 0rem 0.937rem 0rem 0.937rem;
        font-size: 15px;
    }
}

@media only screen and (max-width: 1340px) {
    .nav__link {
        padding: 0.812rem 0.812rem 0.812rem 0.812rem;
        font-size: 12px;
    }
}

@media only screen and (max-width: 767px) {
    .nav__link {
        padding-right: 50px;
    }
}

.nav__row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
}

@media only screen and (max-width: 1340px) {
    .nav__row {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        display: block;
        padding: 0.625rem 0rem 0.625rem 0rem;
    }
}

.nav__subnav {
    display: none;
}

.nav__close-subnav-list {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
}

.nav__close-subnav-button {
    width: 1.25rem;
    height: 1.25rem;
    // background: url("../../dist/images/general/x.png") no-repeat;
    background-size: cover;
    background-position: center;
    display: none;
    z-index: 9;
    right: 1.25rem;
    top: 1.25rem;
    position: absolute;
    cursor: pointer;
}

@media only screen and (max-width: 1490px) {
    .nav {
        margin: 0 1.25rem;
    }
}

@media only screen and (max-width: 1340px) {
    .nav {
        height: auto;
        position: absolute;
        right: 0;
        top: 80px;
        width: 23.437rem;
        background-color: #fff;
        -webkit-box-shadow: 0px 0.125rem 0.875rem 0px rgba(35, 34, 33, 0.1);
        box-shadow: 0px 0.125rem 0.875rem 0px rgba(35, 34, 33, 0.1);
        z-index: 1;
        opacity: 0;
        visibility: hidden;
        -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
        transition: opacity 0.25s ease-in-out, visibility 0.25s;
    }

    .nav__list {
        display: block;
        height: 40px;
        line-height: 3.125rem;
        padding-left: 1.875rem;
        position: relative;
        margin: 0;
        width: 100%;
    }

    .nav__list:before {
        left: 0;
        position: absolute;
        top: 0;
        height: 100%;
        width: 2px;
        background-color: #cf004a;
        content: '';
        opacity: 0;
        visibility: hidden;
        -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
        transition: opacity 0.25s ease-in-out, visibility 0.25s;
    }

    .nav__list:hover:before,
    .nav__list.active:before {
        opacity: 1;
        visibility: visible;
        -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
        transition: opacity 0.25s ease-in-out, visibility 0.25s;
    }

    .nav__list--subnav {
        display: block !important;
    }

    .nav__list--login {
        height: auto;
        padding-left: 0;
    }

    .nav__link {
        padding-right: 3.125rem;
        border-bottom: 0;
    }
}

@media only screen and (max-width: 1340px) and (max-width: 767px) {
    .nav__link {
        border-bottom: 0;
    }
}

@media only screen and (max-width: 1340px) {
    .nav__close-subnav-button {
        display: block;
    }

    .nav__subnav {
        -webkit-transition: left 0.25s ease-in-out;
        transition: left 0.25s ease-in-out;
        display: block;
        position: absolute;
        top: 0;
        /*left: 100%;*/
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .nav__subnav.show {
        left: 0;
    }

    .nav.show {
        opacity: 1;
        visibility: visible;
        -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
        transition: opacity 0.25s ease-in-out, visibility 0.25s;
    }
}

@media only screen and (max-width: 767px) {
    .nav {
        width: 100%;
        padding-bottom: 10px;
    }
}

.header-right {
    // min-width: 200px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: flex-end;
    margin-right: 0.1rem;
}

@media only screen and (max-width: 1340px) {
    .header-right {
        margin-right: 6.25rem;
        height: 100%;
    }
}

@media only screen and (max-width: 767px) {
    .header-right {
        margin-left: 0;
        margin-right: 6.25rem;
    }
}

@media only screen and (max-width: 767px) {
    .header-right__buy-button {
        margin-left: 0.625rem;
        margin-right: 0 !important;
    }
}

.header-right__cart-button {
    width: 1.25rem;
    height: 1.5rem;
    //  background: url("../../dist/images/svg-icons/basket.svg") no-repeat;
    background-size: cover;
    background-position: center;
    margin-right: 1.875rem;
    position: relative;
}

@media only screen and (max-width: 767px) {
    .header-right__cart-button {
        display: none;
        margin-right: 0.937rem;
    }
}

.header-right__cart-number {
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #cf004a;
    border-radius: 50%;
    position: absolute;
    right: -0.5rem;
    top: -0.375rem;
    width: 1.125rem;
    height: 1.125rem;
    font-size: 0.75rem;
    font-weight: 800;
}

.choose-language {
    margin-left: 1.25rem;
}

@media only screen and (max-width: 767px) {
    .choose-language {
        margin-left: 0.625rem;
        margin-right: 0.312rem;
    }
}

.page {
    margin-top: calc(80px + 2px);
}

@media only screen and (max-width: 767px) {
    .page {
        margin-top: 72px;
    }
}

.container {
    padding-top: 3.125rem;
}

.container--page {
    margin-top: 1.562rem;
}

.container--page.rules {
    width: 70%;
    margin: 0 auto;
    margin-bottom: 1.562rem;
}

@media only screen and (max-width: 767px) {
    .container--page.rules {
        width: 100%;
    }
}

.login-form {
    position: relative;
}

@media only screen and (max-width: 767px) {
    .login-form {
        display: none;
    }
}

.login-form__container {
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    border: 1px solid #cdc9c6;
    border-radius: 0.25rem;
    position: absolute;
    right: 0;
    background-color: #fff;
    top: calc(100% + 0.781rem);
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

@media only screen and (max-width: 767px) {
    .login-form__container {
        right: -2px;
        border-color: #ede8e4;
    }
}

.login-form__container:before {
    content: '';
    width: 8.312rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-left: 1px solid #ede8e4;
    border-right: 1px solid #ede8e4;
    position: absolute;
    right: -1px;
    background-color: #fff;
    height: 2rem;
    top: -2rem;
}

@media only screen and (max-width: 767px) {
    .login-form__container:before {
        width: 60px;
        right: -1px;
    }
}

.login-form__container:after {
    content: '';
    height: 0.312rem;
    width: 0.312rem;
    background-color: #fff;
    position: absolute;
    right: -1px;
    top: 0;
    border-right: 1px solid #cdc9c6;
}

.login-form__container.show {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.login-form__container--login {
    position: static;
    top: 0;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
    visibility: visible;
    border: none;
    width: 100%;
    padding-top: 0;
    padding-left: 3.125rem;
}

.login-form__container--login:before {
    display: none;
}

.login-form__container--login:after {
    display: none;
}

@media only screen and (max-width: 767px) {
    .login-form__container {
        padding: 3.125rem 3.125rem 3.125rem 3.125rem;
        padding-top: 0;
    }
}

.login-form__heading {
    font-size: 0.875rem;
    font-weight: 700;
}

.login-form__top {
    border-bottom: 1px solid #cdc9c6;
    padding-bottom: 1.25rem;
    margin-bottom: 1.25rem;
}

@media only screen and (max-width: 767px) {
    .login-form__top {
        margin-bottom: 1.875rem;
        padding-bottom: 2.5rem;
    }
}

.login-form__button {
    margin-top: 0.625rem;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.login-form__login-button {
    width: 8.312rem;
}

.login-form__login-button.-button-arrow {
    margin-right: 0;
}

.login-form__login-button.show-bg.-button-light-grey {
    border-color: #cdc9c6;
    color: #706c69;
}

.login-form__login-button.show-bg.-button-light-grey:before {
    border-color: #706c69 transparent transparent transparent;
}

.login-form__login-button-span {
    position: relative;
    z-index: 1;
    font-size: 0.937rem;
    font-weight: 700;
    font-family: 'Ek Mukta', sans-serif;
}

@media only screen and (max-width: 767px) {
    .login-form__login-button-span {
        display: none;
    }
}

.breadcrumb {
    padding: 1.562rem 0rem 1.562rem 0rem;
}

.breadcrumb__list {
    display: inline-block;
}

.breadcrumb__list:after {
    content: '>';
    margin: 0 0.625rem;
}

.breadcrumb__list:last-child:after {
    display: none;
}

.breadcrumb__list:last-child a {
    color: #cf004a;
    font-weight: 600;
}

.breadcrumb__link {
    font-size: 0.875rem;
    font-weight: 400;
    color: #706c69;
}

.breadcrumb__link:hover {
    text-decoration: underline;
}

.filtering__inner {
    padding: 1.875rem 1.25rem 1.875rem 1.25rem;
    border: 1px solid #ede8e4;
}

@media only screen and (max-width: 767px) {
    .filtering__inner {
        padding: 1.25rem 1.25rem 1.25rem 1.25rem;
        padding-bottom: 0;
    }
}

.filtering__list {
    display: inline-block;
    margin-right: 1.812rem;
}

.filtering__list:last-child {
    margin-right: 0;
}

@media only screen and (max-width: 767px) {
    .filtering__list {
        margin-right: 0;
        margin-bottom: 2.187rem;
        width: 100%;
    }

    .filtering__list:last-child {
        margin-bottom: 1.25rem;
    }
}

.mobile {
    display: none !important;
}

@media only screen and (max-width: 767px) {
    .mobile {
        display: block !important;
    }
}

.desktop {
    display: block !important;
}

@media only screen and (max-width: 767px) {
    .desktop {
        display: none !important;
    }
}

.desktop-table {
    display: table !important;
}

@media only screen and (max-width: 767px) {
    .desktop-table {
        display: none !important;
    }
}

.white-bar {
    padding: 3.375rem 0rem 3.375rem 0rem;
}

@media only screen and (max-width: 767px) {
    .white-bar {
        padding: 1.25rem 0rem 1.25rem 0rem;
    }
}

.white-bar__inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
}

@media only screen and (max-width: 767px) {
    .white-bar__inner {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
}

.white-bar__inner:before {
    content: '';
    height: 1px;
    background-color: #ede8e4;
    width: 100%;
    position: absolute;
    left: 0;
    top: -3.375rem;
}

@media only screen and (max-width: 767px) {
    .white-bar__inner:before {
        display: none;
    }
}

.white-bar__left {
    width: 14%;
}

@media only screen and (max-width: 767px) {
    .white-bar__left {
        width: 40%;
    }
}

.white-bar__center {
    display: inline-block;
}

@media only screen and (max-width: 767px) {
    .white-bar__center {
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
        margin-top: 1.25rem;
    }
}

.white-bar__right {
    width: 14%;
    height: auto;
}

@media only screen and (max-width: 767px) {
    .white-bar__right {
        width: 40%;
    }
}

@media only screen and (max-width: 767px) {
    .white-bar {
        border-top: 1px solid #ede8e4;
    }
}

.black-bar {
    background-color: #2c2525;
}

.black-bar__top {
    padding-top: 2.5rem;
    padding-bottom: 1.25rem;
}

.black-bar__bottom {
    padding: 1.812rem 0rem 1.812rem 0rem;
    border-top: 1px solid rgba(77, 71, 69, 0.4);
}

.black-bar__inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

@media only screen and (max-width: 767px) {
    .black-bar__inner {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
}

.black-bar__newsletter {
    position: relative;
}

.black-bar__newsletter-inner {
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.black-bar__newsletter-inner.show {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

@media only screen and (max-width: 767px) {
    .black-bar__newsletter-inner {
        text-align: left;
    }
}

.black-bar__agreement {
    margin-bottom: 1.25rem;
}

.black-bar__agreement-text {
    color: #fff;
    font-size: 0.775rem;
}

.newsletter-behaviour {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.newsletter-behaviour.show {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.newsletter-behaviour__heading {
    padding-left: 3.125rem;
    position: relative;
    font-weight: 700;
    font-size: 1.25rem;
    color: #fff;
}

.newsletter-behaviour__heading:before {
    content: '';
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 2.5rem;
    height: 2.5rem;
    // background: url("../../dist/images/svg-icons/excl-white.svg") no-repeat;
    background-size: cover;
    background-position: center;
}

.newsletter-behaviour__heading.-icon-close:before {
    //  background: url("../../dist/images/svg-icons/x_popup.svg") no-repeat;
    background-size: cover;
    background-position: center;
}

.newsletter-behaviour__text {
    color: #fff;
    margin: 0.625rem 0 1.25rem;
}

.footer-menu-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 42%;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

@media only screen and (max-width: 767px) {
    .footer-menu-container {
        width: 100%;
        margin-bottom: 1.25rem;
        display: none;
    }
}

.footer-menu__link {
    color: #fff;
    font-weight: 400;
}

.footer-menu__link:hover {
    text-decoration: underline;
}

.newsletter {
    min-width: 23.125rem;
}

@media only screen and (max-width: 767px) {
    .newsletter {
        width: 100%;
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
    }
}

.newsletter__heading {
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 800;
    color: #fff;
}

@media only screen and (max-width: 767px) {
    .newsletter__heading {
        font-size: 1.062rem;
    }
}

.newsletter__text {
    line-height: 1.187rem;
    font-weight: 400;
    color: #fff;
    margin-top: 1.562rem;
    margin-bottom: 0.937rem;
}

@media only screen and (max-width: 767px) {
    .newsletter__text {
        margin-top: 0.625rem;
    }
}

.newsletter__input {
    width: 100%;
}

.newsletter__item {
    margin-bottom: 1.187rem;
    position: relative;
}

.newsletter__item:last-child {
    margin-bottom: 0;
}

.newsletter__item-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.newsletter__item-container .buttons-container {
    text-align: right;
}

.newsletter__item-container-element {
    width: 49%;
}

.newsletter__agreement {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 0;
}

.agreement__button {
    text-decoration: underline;
    font-size: 0.75rem;
    color: #fff;
    font-weight: 500;
}

.agreement--red .agreement__button {
    color: #cf004a;
}

@media only screen and (max-width: 767px) {
    .help-line-item-button {
        width: 100%;
        text-align: center;
    }
}

@media only screen and (max-width: 767px) {
    .help-line {
        margin-top: 0;
        width: 100%;
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
        margin-bottom: 1.875rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
}

.help-line__item {
    text-align: left;
    margin-bottom: 0.625rem;
}

@media only screen and (max-width: 767px) {
    .help-line__item {
        width: 100%;
    }
}

.help-line__number {
    font-size: 1.812rem;
    font-weight: 700;
    color: #fff;
}

.help-line__mail {
    margin-top: 0.625rem;
    color: #fff;
    font-size: 1.187rem;
    font-weight: 700;
    display: block;
}

.slick-dots {
    bottom: 22px;
    width: 100px;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
}

.slick-dots li {
    width: 10px;
    height: 10px;
    margin: 0;
    margin-right: 5px;
}

.slick-dots li:last-child {
    margin-right: 0;
}

.slick-dots li button {
    width: 10px;
    height: 10px;
    border: 2px solid #cdc9c6;
    padding: 0;
    border-radius: 50%;
    -webkit-transition: background-color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out, border-color 0.25s ease-in-out;
}

.slick-dots li button:before {
    display: none;
}

.slick-dots li.slick-active button {
    background-color: #cf004a;
    border-color: #cf004a;
}

.slick-dotted.slick-slider {
    margin-bottom: 0;
}

.accordion__heading {
    padding: 0.875rem 1.25rem 0.875rem 1.25rem;
    font-weight: 500;
    font-size: 1rem;
    color: #706c69;
    border: 1px solid #ede8e4;
    border-radius: 0.25rem;
    cursor: pointer;
    outline: none;
    position: relative;
}

.accordion__heading:first-child {
    border-bottom: none;
}

.accordion__heading:before {
    content: '';
    width: 0.187rem;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    background-color: #cf004a;
    border-radius: 0.125rem 0px 0.125rem 0px;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.accordion__heading:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.375rem 0.287rem 0 0.287rem;
    border-color: #706c69 transparent transparent transparent;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 1.25rem;
}

.accordion__heading.ui-state-active:after {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    top: 44%;
}

.accordion__heading.ui-state-active:first-child {
    border-bottom: 1px solid #ede8e4;
}

.accordion__heading:hover:before,
.accordion__heading.ui-state-active:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.accordion__content {
    padding: 1rem 1rem 1rem 1rem;
}

.accordion__bold {
    color: #333333;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 1.25rem;
}

.dotted-list__list {
    font-weight: 400;
    color: #706c69;
    margin-bottom: 1.25rem;
    padding-left: 0.812rem;
    position: relative;
}

.dotted-list__list:last-child {
    margin-bottom: 0;
}

.dotted-list__list:before {
    content: '';
    border-radius: 50%;
    background-color: #cf004a;
    position: absolute;
    left: 0;
    top: 0.35em;
    width: 0.25rem;
    height: 0.25rem;
}

.dotted-list-text__list {
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    margin-bottom: 1.25rem;
    padding-left: 1.062rem;
    position: relative;
}

.dotted-list-text__list:last-child {
    margin-bottom: 0;
}

.dotted-list-text__list:before {
    content: '';
    border-radius: 50%;
    background-color: #cf004a;
    position: absolute;
    left: 0;
    top: 0.562rem;
    width: 0.437rem;
    height: 0.437rem;
}

th.ui-datepicker-week-end,
td.ui-datepicker-week-end {
    background-color: #f9f8f6;
    pointer-events: none;
}

.half-parent {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.half-parent__block {
    width: calc(50% - 0.625rem);
}

@media only screen and (max-width: 767px) {
    .half-parent {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .half-parent__block {
        width: 100%;
    }
}

.modal {
    max-width: 38.5rem;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: fixed;
    width: 50%;
    padding: 2.5rem 2.5rem 2.5rem 2.5rem;
    border-radius: 0.25rem;
    z-index: 2147483641;
    opacity: 0;
    display: none;
    visibility: none;
}

.modal__list-block-half-parent {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.modal__list-block-half {
    width: calc(50% - 0.625rem);
}

.modal#assign-code {
    padding-bottom: 2.5rem;
}

.modal__title {
    margin-bottom: 1.562rem;
    margin-top: 0;
}

.modal__description {
    font-weight: 500;
    color: #706c69;
    margin-bottom: 1.562rem;
    line-height: 1.25rem;
}

.modal__description--bold {
    font-weight: 800;
}

.modal__description--bigger-height {
    line-height: 2.187rem;
}

.modal__list {
    margin-bottom: 1.25rem;
    width: 100%;
    text-align: center;
}

.modal__list--buttons {
    margin-bottom: 0;
}

.modal__list--agreement {
    font-size: 0.75rem;
    color: #706c69;
    text-align: left;
    margin-top: 1.875rem;
}

.modal__input {
    width: 100%;
}

.modal__close {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
}

.modal.display-block {
    display: block;
}

.modal.show {
    opacity: 1;
    visibility: visible;
}

.modal.show ~ .overlay {
    opacity: 1;
    visibility: visible;
}

@media only screen and (max-width: 767px) {
    .modal {
        width: 100%;
        max-width: none;
        padding: 2.5rem 2.5rem 2.5rem 2.5rem;
        overflow-y: auto;
        -webkit-transform: none;
        transform: none;
        margin: 1.25rem auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .modal .buttons-container__button {
        display: block;
        margin: 0;
        margin-bottom: 1.25rem;
        width: 100%;
    }

    .modal .buttons-container__button:last-child {
        margin-bottom: 0;
    }
}

#mail-modal {
    width: 70%;
    max-width: 54.5rem;
}

#mail-modal .buttons-container {
    text-align: center;
}

#mail-modal .textarea-list {
    height: calc(100% - 1.25rem);
}

#mail-modal .textarea-list .textarea {
    height: 100%;
}

#mail-modal .validation-texts-container {
    margin-bottom: 0.625rem;
}

@media only screen and (max-width: 767px) {
    #mail-modal {
        max-width: 100%;
        width: 92%;
    }
}

.overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    z-index: 2147483640;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.-grey-country {
    color: #706c69 !important;
}

.braster.braster-ui .ui-datepicker {
    display: none;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    border-radius: 0.25rem;
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    margin-top: 0.937rem;
    position: relative;
}

.braster.braster-ui .ui-datepicker thead {
    display: none;
}

.braster.braster-ui .ui-datepicker tbody td {
    width: 40px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    line-height: 2.5rem;
    border: 1px solid #ede8e4;
    font-size: 0.875rem;
    font-weight: 400;
    color: #333333;
}

.braster.braster-ui .ui-datepicker tbody td a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-today {
    position: relative;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-today:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #ebebea;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-today a {
    position: relative;
    color: #333333;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-current-day {
    position: relative;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-current-day:before {
    content: '';
    width: 1.812rem;
    height: 1.812rem;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background-color: #cf004a;
}

.braster.braster-ui .ui-datepicker tbody td.ui-datepicker-current-day a {
    position: relative;
    color: #fff;
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header {
    position: relative;
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-prev,
.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-next {
    position: absolute;
    display: block;
    width: 2.5rem;
    height: 2.5rem;
    height: 1.875rem;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    top: -0.438rem;
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-prev span,
.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-next span {
    font-size: 0;
    // background: url("../../dist/images/general/arrow-left.png") no-repeat;
    background-size: cover;
    background-position: center;
    display: block;
    height: 0.5rem;
    width: 0.875rem;
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-next {
    right: 0;
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-next span {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
}

.braster.braster-ui .ui-datepicker .ui-datepicker-header .ui-datepicker-title {
    text-align: center;
    margin-bottom: 13px;
    font-weight: 700;
    font-size: 0.875rem;
}

.select {
    position: relative;
}

.select__button {
    -webkit-transition: box-shadow 0.25s ease-in-out, border 0.25s ease-in-out;
    -webkit-transition: border 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: border 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: box-shadow 0.25s ease-in-out, border 0.25s ease-in-out;
    transition: box-shadow 0.25s ease-in-out, border 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
}

.select__button.-button-arrow {
    z-index: 2;
    background-color: #fff;
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #706c69;
    width: 100%;
    padding-left: 1.312rem;
    border-color: #fff;
    text-align: left;
}

.select__button.-button-arrow:hover {
    color: #706c69;
    border-color: #fff;
}

.select__button.-button-arrow:hover:before {
    border-color: #706c69 transparent transparent transparent;
}

.select__button.-button-arrow.clicked {
    font-size: 1rem;
    color: #333333;
    font-weight: 600;
}

.select__button.validate {
    border: 2px solid red;
}

.select__button.validate-red {
    -webkit-box-shadow: 10px 10px 50px 20px pink inset;
    box-shadow: 10px 10px 50px 20px pink inset;
    border: 2px solid red;
}

.select__element-button-topic {
    font-weight: 700;
    display: block;
    color: #333333;
    font-size: 1rem;
    text-align: left;
    -webkit-transition: color 0.25s ease-in-out;
    transition: color 0.25s ease-in-out;
}

.select__element-button-description {
    color: #706c69;
    font-weight: 400;
    display: block;
    text-align: left;
    font-size: 0.875rem;
    -webkit-transition: color 0.25s ease-in-out;
    transition: color 0.25s ease-in-out;
}

.select__container {
    background-color: #fff;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    border: 1px solid #ede8e4;
    border-top: none;
    border-bottom-left-radius: 1.562rem;
    border-bottom-right-radius: 1.562rem;
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    padding-top: 1.875rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.select.-grey-select .select__container {
    border: 1px solid #cdc9c6;
}

.select.-grey-select .select__button {
    border: 1px solid #cdc9c6;
}

.select.show .select__container {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.select.show .select__button:before {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    top: 47%;
}

.select__element {
    margin-bottom: 0.625rem;
}

.select__element:last-child {
    margin-bottom: 0;
}

.select__element-button {
    font-weight: 600;
    font-size: 0.875rem;
    color: #706c69;
    -webkit-transition: color 0.25s ease-in-out, font-weight 0.25s ease-in-out;
    transition: color 0.25s ease-in-out, font-weight 0.25s ease-in-out;
}

.select__element-button:hover {
    color: #cf004a;
    font-weight: 700;
}

.select__element-button:hover .select__element-button-description {
    color: #cf004a;
}

.select__element-button:hover .select__element-button-topic {
    color: #cf004a;
}

.select__element-button.-border-bottom {
    border-bottom: 1px solid #ede8e4;
    padding-bottom: 0.625rem;
    width: 100%;
}

.markets {
    padding-top: 3.312rem;
    padding-bottom: 3.5rem;
    padding-left: 5.375rem;
    padding-right: 5.375rem;
    text-align: center;
}

.markets__go {
    margin-right: 0 !important;
    margin-bottom: 1.25rem;
}

.markets__go,
.markets__stay {
    position: relative;
    width: 21.875rem;
}

.markets__go:before,
.markets__stay:before {
    content: '';
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 1.25rem;
}

.markets__go.-poland-flag:before,
.markets__stay.-poland-flag:before {
    border: 1px solid #ede8e4;
}

.cookies-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    background-color: #fff;
    border: 1px solid #ede8e4;
    border-radius: 0.25rem;
    -webkit-box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    max-width: 400px;
    z-index: 2147483641;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.cookies-container__inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.cookies-container__text {
    color: #706c69;
    font-size: 1rem;
    font-weight: 400;
    margin-bottom: 1.875rem;
}

.cookies-container.show {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

@media only screen and (max-width: 767px) {
    .cookies-container {
        width: 100%;
        bottom: 0;
        left: 0;
    }
}

.clouds-mobile-container {
    z-index: 2147483641;
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
    padding-top: 2.5rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    box-shadow: 0px 0px 0.875rem 0px #cdc9c6;
    border: 1px solid #ede8e4;
    width: 100%;
    -webkit-transition: transform 0.25s ease-in-out;
    -webkit-transition: -webkit-transform 0.25s ease-in-out;
    transition: -webkit-transform 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
    -webkit-transform: translateY(150%);
    transform: translateY(150%);
}

.clouds-mobile-container__close {
    position: absolute;
    right: 10px;
    top: 10px;
}

.clouds-mobile-container.show {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}

.logo-slider {
    position: relative;
    padding: 0rem 3.75rem 0rem 3.75rem;
    margin: 3.125rem 0;
}

.logo-slider__link {
    display: block;
    position: relative;
    padding-bottom: 50%;
}

.logo-slider__image {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    -o-object-fit: contain;
    object-fit: contain;
}

.logo-slider__arrow {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 3.5rem;
    height: 1.875rem;
    border-radius: 0.937rem;
    border: 1px solid #ede8e4;
    -webkit-transition: border-color 0.25s ease-in-out;
    transition: border-color 0.25s ease-in-out;
}

.logo-slider__arrow:after {
    content: '';
    // background: url("../../dist/images/carousel/arrow.png") no-repeat;
    background-size: cover;
    background-position: center;
    width: 1rem;
    height: 0.437rem;
}

.logo-slider__arrow--right {
    right: 0;
}

.logo-slider__arrow--right:after {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.logo-slider__arrow--left {
    left: 0;
}

.logo-slider__arrow--left:after {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    margin: auto;
}

.logo-slider__arrow:hover {
    border-color: #cf004a;
}

.red-bar-container.-margin-bottom {
    margin-bottom: 1.25rem;
}

.red-bar-container.-margin {
    margin: 1.25rem 0;
}

.red-bar-container.-margin-top {
    margin-top: 1.25rem;
}

.red-text-bar {
    background-color: #cf004a;
    padding: 1.25rem 1.25rem 1.25rem 1.25rem;
}

.red-text-bar__text {
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
}

/*# sourceMappingURL=style.css.map */

.login-buy-disabled {
    opacity: 0.6;

    &:hover {
        background-color: #cf004a;
        color: #fff;
        border-color: #cf004a;
    }
}
</style>



// WEBPACK FOOTER //
// the-header.vue?3ad3cfb6